import React from 'react';

const Editor = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27",
    height: "28",
    viewBox: "0 0 27 28",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1443_17314)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.0616 21.8491L13.3953 18.4332L7.72912 21.8491L9.2294 15.4059L4.23293 11.0792L10.8234 10.5166L13.3953 4.43511L15.9673 10.5032L22.5578 11.0658L17.5613 15.3925L19.0616 21.8491ZM13.3953 0.416504C5.98772 0.416504 0 6.44441 0 13.8119C0 17.3645 1.41129 20.7717 3.92341 23.2838C5.16728 24.5277 6.64397 25.5144 8.26917 26.1875C9.89437 26.8607 11.6362 27.2072 13.3953 27.2072C16.948 27.2072 20.3552 25.7959 22.8673 23.2838C25.3794 20.7717 26.7907 17.3645 26.7907 13.8119C26.7907 12.0528 26.4442 10.3109 25.771 8.68567C25.0979 7.06048 24.1112 5.58378 22.8673 4.33991C21.6234 3.09604 20.1467 2.10934 18.5215 1.43616C16.8963 0.762985 15.1545 0.416504 13.3953 0.416504Z",
      fill: "#4FE2FF"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1443_17314" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "26.7907",
      height: "26.7907",
      fill: "white",
      transform: "translate(0 0.416504)"
    }
  )))
);

export { Editor };
//# sourceMappingURL=Editor.js.map
